import AuthenticationForm from "components/Authentication/AuthenticationForm";
import { useState } from "react";
import { register, login } from "api/Accounts/AccountsAPI";
import { isValidEmail } from "components/Authentication/fieldValidators";
import { validateRegister } from "api/Accounts/AccountsAPI";


interface StepAccountProps {
  data: any;
  error: Record<string, string> | null;
  onNext: (values: any) => void;
}

export default function StepAccount({
  data,
  error,
  onNext,
}: StepAccountProps) {
  const [localError, setLocalError] = useState<Record<string, string> | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleNext(values: any) {
    if (submitting) return;

    const errors: Record<string, string> = {};

    if (!isValidEmail(values.email)) {
      errors.email = "Please enter a valid email address.";
    }

    if (values.password !== values.confirm) {
      errors.confirm = "Passwords do not match.";
    }

    if (Object.keys(errors).length > 0) {
      setLocalError(errors);
      return;
    }

    try {
      setSubmitting(true);
      setLocalError(null);

      // ✅ BACKEND VALIDATION ONLY
      await validateRegister({
        username: values.username,
        email: values.email,
        password: values.password,
      });

      // ✅ Move forward
      onNext(values);
    } catch (err: any) {
      setLocalError(err.response?.data || {
        _form: "Validation failed",
      });
    } finally {
      setSubmitting(false);
    }
  }

  
  return (
    <AuthenticationForm
      title="Create Your Personal Account"
      submitLabel="Next"
      error={{ ...error, ...localError }}
      fields={[
        { name: "username", label: "Username", required: true },
        { name: "email", label: "Email", type: "email", required: true },
        { name: "password", label: "Password", type: "password", required: true },
        { name: "confirm", label: "Confirm Password", type: "password", required: true },
      ]}
      initialValues={data}
      onSubmit={handleNext}
    />
  );
}
